import React, {FC, useContext, useEffect} from "react";
import {Outlet, useParams} from "react-router-dom";
import {VisitorContext} from "../../../../context/data/VisitorContext";
import {useOrganizationList} from "../../../../hooks/lists/useOrganizationList";

const SetVisitorContext: FC<any> = (props) => {
    const { organizationShortCode} = useParams();
    const { setServiceOrganizationId, setServiceOrganizationShortCode } = useContext(VisitorContext);
    const { activeOrganizationList } = useOrganizationList();

    useEffect(() => {
        if (activeOrganizationList.length && organizationShortCode) {
            const organizationInfo = activeOrganizationList.find((o) => o.short_name.toUpperCase() == String(organizationShortCode).toUpperCase());
            if (organizationInfo) {
                const organizationId = organizationInfo.id;
                const organizationShortCode = organizationInfo.short_name;
                setServiceOrganizationId(organizationId);
                setServiceOrganizationShortCode(organizationShortCode);
            }
        }
    }, [activeOrganizationList.length, organizationShortCode]);


    return <Outlet />;
};

export default SetVisitorContext;
